export default __webpack_public_path__ + "static/media/jira.08d3740a.png";